import React from 'react'
import { Text } from '@cred/react-text'
import { RateScript as Rate } from '@cred/react-rate/rate-script'
import { PERSONAL_LOAN_HEADER_TEXT } from '../../constants'

const DefaultHeader = () => (
  <>
    <Text type="subheader">{PERSONAL_LOAN_HEADER_TEXT}</Text>
    <Text className="mb-24 mb-sm-8 mt-sm-8" type="body-alt">
    Rates from <Rate rateType="apr" vertical="personal" variable={false} name="min" /> fixed
      APR with loans from $1,000 to $100,000
    </Text>
  </>
)

export default DefaultHeader
